import { useQuery } from "@tanstack/react-query";
import { SliderImagesAPI } from "../api";

const fetchData = () => {
  return SliderImagesAPI.get();
};
export const useFetchSliderImages = () => {
  return useQuery({
    queryKey: ["slider-images"],
    queryFn: fetchData,
  });
};
